<ion-header class="header" mode="md">
  <ion-grid fixed class="ion-no-padding">
  <ion-toolbar mode="md">

    <ion-title class="hidden-sm-up ion-text-center header-title" size="small" style="font-size:14px !important">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;JAZ</ion-title>

    <ion-title class="hidden-xs-down ion-text-center header-title" size="small" style="font-size:14px !important">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;JAZ by Ana Roš</ion-title>

    <!--<ion-buttons slot="start" class="header-buttons">
      <ion-back-button color="secondary" defaultHref="../../"></ion-back-button>
    </ion-buttons>-->

    <ion-buttons slot="start" class="header-buttons" style="margin-left:-6px">
      <ion-button (click)="back()" class="header-buttons__btn">
        <ion-icon name="arrow-back-sharp" slot="icon-only" shape="round" ></ion-icon>
      </ion-button>
    </ion-buttons>

    <app-top-right slot="end"></app-top-right>

  </ion-toolbar>
  </ion-grid>
</ion-header>



<ion-progress-bar style="height: 2px;" color="secondary" value=".25" buffer="1"></ion-progress-bar>


<ion-grid class="ion-no-padding stepper" style="padding-bottom:10px;">
  <ion-row  class="ion-no-padding">
    <ion-col style="padding:10px;" size-xs="12" offset-xs="0" size-md="6" offset-md="3" size-lg="4" offset-lg="4">

      <h2 class="ion-text-center" style="padding-top:40px; padding-bottom:60px;">{{ 'PICK_SLOT_PREMIUM.SLOGAN' | translate }}</h2>

      <div>
        <!--style="border:1px solid #EFEFEF; padding:5px;"-->
        <img class="rounded-image"  alt="Silhouette of mountains" src="../../../assets/images/jaz_by_ana_ros_3.jpg" />

        <h3 style="padding-left:6px; font-weight:bold; font-size:16px; margin-top:30px">{{ 'PICK_SLOT_PREMIUM.JAZ_LUNCH_TITLE' | translate }}</h3>
        
        <!--h4 style="padding-left:6px; color:gray; font-size:16px;">85 €/osebo</h4-->
        <h4 style="padding-left:6px; color:gray; font-size:16px;">12:00 -14:00</h4>

        <!--h5 style="padding-left:6px; color:gray; font-size:12px; margin-bottom:30px">Možnost vinske spremljave (38 €/osebo)</h5-->
        <h5 style="padding-left:6px; color:gray; font-size:12px; margin-bottom:30px">{{ 'PICK_SLOT_PREMIUM.DURATION' | translate }} 120 min</h5>


        <!--ion-button [color]="'secondary'" size="small" expand="block" class="btn--large ion-no-margin bottom-btn">Izberi sedaj</ion-button-->
        <ion-button [queryParams]="{}" [routerLink]="['/', 'restavracija', 392, 'jaz-by-me', 'rezervacija', 'izberi-termin']" expand="block" style="--border-radius: 10px; --background: #FFA500; font-size: 15px; height: 50px;" mode="md" color="secondary">{{ 'PICK_SLOT_PREMIUM.PICK_SLOT_BTN' | translate }}</ion-button>

      </div>

      <div style="margin-top:80px; margin-bottom:50px;">
        <!--style="border:1px solid #EFEFEF; padding:5px;"-->
        <img class="rounded-image"  alt="Silhouette of mountains" src="../../../assets/images/jaz_by_ana_ros_4.jpg" />

        <h3 style="padding-left:6px; font-weight:bold; font-size:16px; margin-top:30px">{{ 'PICK_SLOT_PREMIUM.JAZ_DINNER_TITLE' | translate }}</h3>
        <!--h4 style="padding-left:6px; color:gray; font-size:12px;">Na voljo za do 6 gostov</h4-->

        <h4 style="padding-left:6px; color:gray; font-size:16px;">17:00 - 21:30</h4>

        <h5 style="padding-left:6px; color:gray; font-size:12px; margin-bottom:30px">{{ 'PICK_SLOT_PREMIUM.DURATION' | translate }} 120 min</h5>

        <!--ion-button [color]="'secondary'" size="small" expand="block" class="btn--large ion-no-margin bottom-btn">Izberi sedaj</ion-button-->
        <ion-button [queryParams]="{filter: 19858}" [routerLink]="['/', 'restavracija', 392, 'jaz-by-me', 'rezervacija', 'izberi-termin']" expand="block" style="--border-radius: 10px; --background: #FFA500; font-size: 15px; height: 50px;" mode="md" color="secondary">{{ 'PICK_SLOT_PREMIUM.PICK_SLOT_BTN' | translate }}</ion-button>

      </div>

      <!--div style="margin-top:80px; margin-bottom:50px;">

        <img class="rounded-image"  alt="Silhouette of mountains" src="../../../assets/images/strelecMeni4.jpg" />

        <h3 style="padding-left:6px; font-weight:bold; font-size:16px; margin-top:30px">9-HODNI DEGUSTACIJSKI MENI</h3>

        <h4 style="padding-left:6px; color:gray; font-size:16px;">125 €/osebo</h4>

        <h5 style="padding-left:6px; color:gray; font-size:12px; margin-bottom:30px">Možnost vinske spremljave (60 €/osebo)</h5>

        <ion-button [queryParams]="{menu: 3}" [routerLink]="['/', 'restavracija', 344, 'restavracija-strelec', 'rezervacija', 'izberi-termin']" expand="block" style="--border-radius: 10px; --background: #FFA500; font-size: 15px; height: 50px;" mode="md" color="secondary">Izberi sedaj</ion-button>

      </div-->
      
    </ion-col>
  </ion-row>


</ion-grid>